import React, { Component } from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions";
import JolionPro from "./jolionPro";

class App extends Component {
  constructor() {
    super();
    this.state = {
      stockfilters: {},
    };
  }

  setStockFilters(stockfilters) {
    this.setState({ stockfilters });
  }

  render() {
    return (
      <BrowserRouter basename="/haval-jolion-pro">
        <Route exact path="/" component={JolionPro} />
      </BrowserRouter>
    );
  }
}

export default connect(null, actions)(App);



// WEBPACK FOOTER //
// ./src/components/App.js